export default __webpack_public_path__ + "static/media/SWT0180.34I-19320_-16786_0.05380ca8.jpg";